import React, { useState } from 'react';
import type { TextFieldProps } from '../../types/interface';
import { getTranslatedText } from '@nile/components';
import { DeviceTypeBadges } from '../DeviceTypeBadges';
import { DisplayText, TextField as SuperopsTextField, Button } from '@superops/ui-design-system';
import { translateUiDataProp } from '../../utils/localizationUtils';
import { getMarginLeft } from '../../utils/MdmUtils';
import { SVGIcon } from '@superops/super-icons';


const TextField = ({
  intl,
  label,
  level = 0,
  value,
  onChange,
  onBlur,
  placeholder,
  type = 'text',
  error = null,
  disabled = false,
  minValue,
  maxValue,
  supportedDeviceTypes = [],
  showDeviceTypeBadges = false,
  isParentSectionHovered = false,
  attributeDescription = '',
  uiDataProp = null,
  minOsVersion
}: TextFieldProps) => {
  const shouldShowBadge = showDeviceTypeBadges && supportedDeviceTypes.length > 0;
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  // Determine actual input type based on original type and visibility state
  const actualType = type === 'password' && isPasswordVisible ? 'text' : type;

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleBlur = (value: string) => {
    if (onBlur) {
      onBlur(value);
    }
  };

  // Translate all localizable properties in uiDataProp
  const translatedUiDataProp = translateUiDataProp(intl, uiDataProp);


  return (
    <div>
      <div className={`flex ${getMarginLeft(level)} ${uiDataProp?.vertical ? 'col' : 'actr'} g20`}>
        {!uiDataProp?.vertical &&
          <div className='w350'>
            <DisplayText
              element="p"
              size="large"
              weight="Medium"
            >
              {getTranslatedText(intl, label)}
            </DisplayText>
          </div>
        }
        <div>
          <div className='flex actr g10'>
            <div className={`${!uiDataProp?.vertical ? 'w200' : 'fw mt-15'}`}>
              <SuperopsTextField
                value={value}
                onChange={onChange}
                onBlur={handleBlur}
                disabled={disabled}
                placeholder={placeholder ? getTranslatedText(intl, placeholder) : placeholder}
                type={actualType}
                error={error}
                minValue={minValue}
                maxValue={maxValue}
                suffix={type === 'password' ? (
                  <div className='ml-10'>
                    <Button
                      plain
                      size="tiny"
                      icon={<SVGIcon name={isPasswordVisible ? 'EyeVisible' : 'EyeHidden'} />}
                      onClick={togglePasswordVisibility}
                    />
                  </div>
                ) : undefined}
                {...translatedUiDataProp}
              />
            </div>
            <DeviceTypeBadges
              intl={intl}
              supportedDeviceTypes={supportedDeviceTypes}
              shouldShow={shouldShowBadge && isParentSectionHovered}
            />
          </div>
        </div>
      </div>
      {attributeDescription && (
        <div className="mt5">
          <DisplayText element="p" size="medium" variant="subdued">
            {getTranslatedText(intl, attributeDescription, { minOsVersion })}
          </DisplayText>
        </div>
      )}
    </div>
  );
};

export default TextField;
